import { render, staticRenderFns } from "./CourseUnitModel.vue?vue&type=template&id=ac839f94&scoped=true"
import script from "./CourseUnitModel.vue?vue&type=script&lang=js"
export * from "./CourseUnitModel.vue?vue&type=script&lang=js"
import style0 from "./CourseUnitModel.vue?vue&type=style&index=0&id=ac839f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac839f94",
  null
  
)

export default component.exports